import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { AdminApi, AdminCourse } from '../../services/adminApi'
import { toast } from 'react-toastify'

const AdminCoursesPage = () => {
  const [courses, setCourses] = useState<AdminCourse[]>([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        setLoading(true)
        const response = await AdminApi.getCourses()
        if (response.success && response.data?.items) {
          setCourses(response.data.items)
        } else {
          toast.error('Không thể lấy danh sách khóa học')
        }
      } catch (error) {
        console.error('Error fetching admin courses:', error)
        toast.error('Có lỗi xảy ra khi tải danh sách khóa học')
      } finally {
        setLoading(false)
      }
    }

    fetchCourses()
  }, [])

  const methodLabel = (method?: string) => {
    const m = (method || '').toUpperCase()
    if (m === 'VIDEO') return 'Video'
    if (m === 'ONLINE') return 'Trực tuyến'
    if (m === 'OFFLINE') return 'Offline'
    if (m === 'HYBIRID' || m === 'HYBRID') return 'Hybrid'
    return method || 'Chưa rõ'
  }

  return (
    <div className="bg-m2-surface-container p-6 rounded-lg shadow-sm">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-m2-on-surface">Quản lý Khóa Học</h1>
        <button
          type="button"
          onClick={() => navigate('/admin/courses/new')}
          className="bg-m2-primary text-m2-on-primary px-4 py-2 rounded-md hover:bg-eh-forest-shadow"
        >
          Thêm Khóa Học Mới
        </button>
      </div>

      {loading ? (
        <p>Đang tải...</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-m2-outline-variant">
            <thead className="bg-m2-surface-low">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-m2-on-surface-variant uppercase tracking-wider">ID</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-m2-on-surface-variant uppercase tracking-wider">Tên Khóa Học</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-m2-on-surface-variant uppercase tracking-wider">Học phí</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-m2-on-surface-variant uppercase tracking-wider">Hình thức</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-m2-on-surface-variant uppercase tracking-wider">Trạng Thái</th>
                <th className="px-6 py-3 text-right text-xs font-medium text-m2-on-surface-variant uppercase tracking-wider">Hành Động</th>
              </tr>
            </thead>
            <tbody className="bg-m2-surface-container divide-y divide-m2-outline-variant">
              {courses.map((course) => (
                <tr key={course.id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-m2-on-surface-variant">#{course.id}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-m2-on-surface">{course.name}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-m2-on-surface-variant">
                    {course.fee
                      ? new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(
                          Number(course.fee)
                        )
                      : 'Miễn phí'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-m2-on-surface-variant">{methodLabel(course.method)}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    <span
                      className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                        (course.status || '').toUpperCase() === 'ACTIVE' || course.is_active
                          ? 'bg-m2-secondary/15 text-green-800'
                          : 'bg-m2-surface-high text-m2-on-surface'
                      }`}
                    >
                      {course.status || (course.is_active ? 'ACTIVE' : 'INACTIVE')}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <Link to={`/admin/courses/${course.id}`} className="text-m2-primary hover:text-m2-on-surface mr-4">
                      Chi tiết
                    </Link>
                    <Link to={`/admin/courses/${course.id}/edit`} className="text-eh-forest-ink hover:text-eh-forest-shadow">
                      Sửa
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

export default AdminCoursesPage
